import httpRequest from '../../utils/httpRequest'
import { setLoading } from '../global/action'

export const SET_OPEN_ORDERS = 'SET_OPEN_ORDERS'

export const SET_ORDER_HISTORY = 'SET_ORDER_HISTORY'

export const SET_FETCH_OPENORDERS = 'SET_FETCH_OPENORDERS'

export const setOpenOrder = data => dispatch => dispatch({ type: SET_OPEN_ORDERS, data })

export const setOrderHistory = data => dispatch => dispatch({ type: SET_ORDER_HISTORY, data })

export const setFetchOpenOrder = data => dispatch => dispatch({ type: SET_FETCH_OPENORDERS, data })

export const getOpenOrdersQS = params => async dispatch => {
  try {
    dispatch(setFetchOpenOrder(true))
    const openOrders = await httpRequest.getOpenOrdersQS(params)
    dispatch(setOpenOrder(openOrders))
    dispatch(setFetchOpenOrder(false))
  } catch (err) {
    dispatch(setFetchOpenOrder(false))
    console.log(`status:${err.status} message: ${err.statusText}`)
  }
}

export const getOrderHistoryQS = (params, withLoading) => async dispatch => {
  try {
    if (withLoading) dispatch(setLoading(true))
    const orderHistory = await httpRequest.getOrderHistoryQS(params)
    dispatch(setOrderHistory(orderHistory))
    if (withLoading) dispatch(setLoading(false))
  } catch (err) {
    console.log(`status:${err.status} message: ${err.statusText}`)
    if (withLoading) dispatch(setLoading(false))
  }
}
